import { InjectionToken } from "@angular/core";
import { WalletRechargesPort } from "./wallet-recharges.port";

export const WALLET_RECHARGES_PORT =
  new InjectionToken<WalletRechargesPort>("WALLET_RECHARGES_PORT");
